import { CiDollar } from "react-icons/ci";
import { MdOutlineCallToAction } from "react-icons/md";
import { LuShip } from "react-icons/lu";
import { LuCircleDollarSign } from "react-icons/lu";
import { TbStack } from "react-icons/tb";
import { IoCheckmarkCircle } from "react-icons/io5";
import { GoDotFill } from "react-icons/go";
import { BsFiletypePdf } from "react-icons/bs";
import { GoDownload } from "react-icons/go";
import { RxBox } from "react-icons/rx";
import { MdOutlinePending } from "react-icons/md";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import RecentDeliveryAccordion from "./RecentDel";
import { RiFundsBoxLine } from "react-icons/ri";
import { useEffect, useState } from "react";
import axios from "../../api/axios";

export default function ADLandingUi() {
	const [userData, setUserData] = useState();
	useEffect(() => {
		const fetchShippers = async () => {
			console.log("hi");
			try {
				const response = await axios("/all-shipments");
				console.log(response);
				if (response?.status === 200) {
					setUserData(response?.data?.shipments);
				}
			} catch (error) {
				console.log(error);
			}
		};

		fetchShippers();

		return () => {};
	}, []);

	const recentOrders = [
		{
			product: "iron ore",
			status: "confirmed",
			eta: "15 June 2025",
			id: "#2001",
		},
		{ product: "chrome", status: "pending", eta: "------", id: "#2001" },
		{
			product: "Lead concentrate",
			status: "in transit",
			eta: "28 May 2025",
			id: "#2002",
		},
		{
			product: "iron ore",
			status: "confirmed",
			eta: "15 June 2025",
			id: "#2003",
		},
		{
			product: "iron ore",
			status: "confirmed",
			eta: "15 June 2025",
			id: "#2004",
		},
	];

	const recentTransactions = [
		{
			amount: "$30,000",
			status: "completed",
			date: "15 June 2025",
			id: "#2001",
		},
		{ amount: "$30,000", status: "pending", date: "------", id: "------" },
		{ amount: "$30,000", status: "pending", date: "28 May ", id: "#2002" },
		{
			amount: "$30,000",
			status: "completed",
			date: "15 June 2025",
			id: "#2003",
		},
		{
			amount: "$30,000",
			status: "pending",
			date: "15 June 2025",
			id: "#2004",
		},
	];

	const billingHistory = [
		{
			title: "Miners Pack",
			date: "Dec 2022",
			status: "paid",
			amount: "USD $10,000",
			id: 1,
		},
		{
			title: "Miners Pack",
			date: "Dec 2022",
			status: "paid",
			amount: "USD $10,000",
			id: 2,
		},
		{
			title: "Miners Pack",
			date: "Dec 2022",
			status: "paid",
			amount: "USD $10,000",
			id: 3,
		},
		{
			title: "Miners Pack",
			date: "Dec 2022",
			status: "paid",
			amount: "USD $10,000",
			id: 4,
		},
		{
			title: "Miners Pack",
			date: "Dec 2022",
			status: "paid",
			amount: "USD $10,000",
			id: 5,
		},
		{
			title: "Miners Pack",
			date: "Dec 2022",
			status: "paid",
			amount: "USD $10,000",
			id: 6,
		},
	];

	// console.log(userData.length);

	const loader = <span className="animate-pulse">...</span>;

	const totalShipments =
		typeof userData === "undefined" ? loader : Number(userData?.length);

	const awaitedShipments =
		typeof userData === "undefined"
			? loader
			: userData?.length === 0
			? 0
			: userData.filter((d) => d.shipmentStatus != "Delivered").length;

	const fufilledShipments =
		typeof userData === "undefined"
			? loader
			: userData?.length === 0
			? 0
			: userData.filter((d) => d.shipmentStatus === "Delivered").length;

	console.log(fufilledShipments);
	console.log(awaitedShipments);

	console.log(totalShipments);

	const content = (
		<section className="  min-h-screen  w-[95%] pb-[1rem] mx-auto   flex flex-col   justify-around items-center  gap-[2rem]">
			{/* dashboard overview section */}
			<section className="md:w-[95%]  flex flex-col   justify-around items-center  gap-[2rem]">
				<div className=" w-full  text-left pl-[1rem]  ">
					<h2 className="text-[1.2rem]  font-bold  capitalize">
						Dashboard Overview
					</h2>
					<p className="text-gray-500">
						Here's a quick look at your recent activity and account status
					</p>
				</div>

				<div className=" w-[95%] md:w-[98%] mx-auto md:mx-0  md:mr-auto   flex  md:flex-row flex-col justify-center  md:justify-start items-center  gap-[1rem]  ">
					<div className="  min-h-[7rem]  w-[98%]  px-[1rem] flex  flex-col  justify-center  gap-[0.5rem]    items-start shadow-sm shadow-gray-200  border-2   border-gray-300    rounded-lg">
						<p>
							{" "}
							<LuCircleDollarSign className="text-[1.4rem] inline-block  border-2 border-gray-400   rounded-[0.2rem] p-[0.2rem] mr-[0.3rem]  " />{" "}
							<span className="capitalize  font-medium">Total shipments</span>
						</p>
						<p className="text-[1.8rem]  font-bold">{totalShipments}</p>
					</div>
					<div className="  min-h-[7rem]  w-[98%]  px-[1rem] flex  flex-col  justify-center  gap-[0.5rem]    items-start shadow-sm shadow-gray-200  border-2   border-gray-300    rounded-lg">
						<p>
							{" "}
							<MdOutlineCallToAction className="text-[1.4rem] inline-block  border-2 border-gray-400   rounded-[0.2rem] p-[0.2rem] mr-[0.3rem] " />{" "}
							<span className="capitalize  font-medium">Awaited shipments</span>
						</p>
						<p className="text-[1.8rem]  font-bold">{awaitedShipments}</p>
					</div>
					<div className="  min-h-[7rem]  w-[98%]  px-[1rem] flex  flex-col  justify-center  gap-[0.5rem]    items-start shadow-sm shadow-gray-200  border-2   border-gray-300    rounded-lg">
						<p>
							{" "}
							<LuShip className="text-[1.8rem] inline-block  border-2 border-gray-400 rounded-[0.2rem] p-[0.2rem] mr-[0.3rem] " />{" "}
							<span className="capitalize  font-medium">
								Fufilled Shipments
							</span>
						</p>
						<p className="text-[1.8rem]  font-bold">{fufilledShipments}</p>
					</div>
				</div>
			</section>

			{/* miner pack & recent documents section */}

			<section className="w-[95%]  mx-auto flex  flex-col  md:flex-row   justify-center  items-start   gap-[1rem]">
				{/*	<div>
					 <div className="min-w-full   min-h-full  pb-[1rem]  rounded-lg  border-2 border-gray-300">
						<p className=" w-full   text-green-500   min-h-[4rem]  flex  justify-between  px-[1rem] items-center   border-b-2 border-b-gray-300">
							<span>
								{" "}
								<RiFundsBoxLine className="inline-block  mr-[0.7rem]" />{" "}
								<span>Revenue</span>
							</span>{" "}
							<IoCheckmarkCircle />
						</p>

						<div className="min-h-[11rem]  px-[1rem]   flex  flex-col   justify-center  items-start  gap-[1rem] ">
							<div className="   mx-auto flex flex-col  md:flex-row  justify-center  md:justify-between  items-start gap-[1rem]">
								{" "}
								<p className="md:min-w-[70%]     ">
									<span className="text-[2rem]  font-bold">$300</span>
									<sub className="text-gray-500  inline  text-[0.8rem]">
										per month
									</sub>{" "}
								</p>
								<span className="text-gray-500  text-[0.75rem]">
									{" "}
									Monthly shipment revenue{" "}
								</span>
							</div>
							<p className="border-2  px-[0.5rem]   w-fit   border-gray-300  rounded-md">
								{" "}
								<GoDotFill className="inline-block  text-green-500" /> Active
							</p>
						</div>
						<div className="flex   flex-col   justify-start items-start  lg:items-end  lg:gap-[0.9rem] lg:flex-row-reverse   px-[0.8rem] ">
							<div className="text-[0.9rem]   flex   flex-row gap-[0.5rem] md:flex-col  justify-start items-center">
								<p className="text-gray-500  ">Renewal Date</p>{" "}
								<p className="font-bold text-black">25 June 2025</p>
							</div>
							<div className="flex  justify-between  gap-[0.4rem]  items-center">
								<button className="bg-green-500 block  font-thin  text-[0.9rem]  rounded-md py-[0.2rem] px-[0.5rem]  text-white">
									Renew subscription
								</button>
								<p className="border-2  border-gray-300  font-thin    text-[0.9rem]   rounded-md  py-[0.2rem]   px-[1rem]">
									View benefits
								</p>
							</div>
						</div>
					</div>
				</div> */}

				{/* recent deliveries */}
				<div className="    min-h-[8rem]   w-full  flex  flex-col rounded-lg justify-center items-center   border-2  border-gray-300   ">
					<p className="font-bold  my-[1rem] ">Recent Deliveries</p>
					<hr className="w-[90%]" />
					<div className=" w-full   pb-[1rem]  px-[0.5rem]  flex flex-col  justify-center items-center gap-[1rem]">
						<RecentDeliveryAccordion userData={userData} status={"Delivered"} />
						{/* <div className=" min-w-[90%]  px-[1rem]  min-h-[3rem]     flex  justify-around  items-center gap-[0.5rem]  border-2  border-gray-300  rounded-lg   ">
							<LocalShippingIcon className="inline-block  text-red-500" />{" "}
							<p>Purchase Order {"PO_10329.pdf"}</p>{" "}
							<RemoveRedEyeIcon className=" text-[1.6rem]  p-[0.3rem] rounded-full border-2  border-gray-300   inline-block" />
						</div>
						<div className=" min-w-[90%]  px-[1rem]  min-h-[3rem]     flex  justify-around  items-center gap-[0.5rem]  border-2  border-gray-300  rounded-lg   ">
							<BsFiletypePdf className="inline-block  text-red-500" />{" "}
							<p>Purchase Order {"PO_10329.pdf"} </p>{" "}
							<GoDownload className=" text-[1.6rem]  p-[0.3rem] rounded-full border-2  border-gray-300   inline-block" />
						</div> */}
					</div>
				</div>
				{/* recent pickups */}
				<div className="    min-h-[8rem]   w-full  flex  flex-col rounded-lg justify-center items-center   border-2  border-gray-300   ">
					<p className="font-bold  my-[1rem] ">Recent Pick ups</p>
					<hr className="w-[90%]" />
					<div className=" w-full   pb-[1rem]  px-[0.5rem]  flex flex-col  justify-center items-center gap-[1rem]">
						<RecentDeliveryAccordion
							userData={userData}
							status={"out for delivery"}
						/>
						{/* <div className=" min-w-[90%]  px-[1rem]  min-h-[3rem]     flex  justify-around  items-center gap-[0.5rem]  border-2  border-gray-300  rounded-lg   ">
							<LocalShippingIcon className="inline-block  text-red-500" />{" "}
							<p>Purchase Order {"PO_10329.pdf"}</p>{" "}
							<RemoveRedEyeIcon className=" text-[1.6rem]  p-[0.3rem] rounded-full border-2  border-gray-300   inline-block" />
						</div>
						<div className=" min-w-[90%]  px-[1rem]  min-h-[3rem]     flex  justify-around  items-center gap-[0.5rem]  border-2  border-gray-300  rounded-lg   ">
							<BsFiletypePdf className="inline-block  text-red-500" />{" "}
							<p>Purchase Order {"PO_10329.pdf"} </p>{" "}
							<GoDownload className=" text-[1.6rem]  p-[0.3rem] rounded-full border-2  border-gray-300   inline-block" />
						</div> */}
					</div>
				</div>
			</section>

			{/* recent transactions, recent orders and billing history */}

			{/* <section className="w-[95%] min-h-full  flex  flex-col   md:flex-row   gap-[1rem] justify-center items-center ">
				recent transactions & orders
				<div className=" w-full   min-h-full     flex flex-col   justify-center items-center gap-[1.5rem]">
					recent orders
					<div className="w-full p-[0.5rem] min-h-full  border-2  border-gray-300   rounded-md">
						<div className="flex  justify-start items-center gap-[3rem]  my-[0.5rem]">
							<h5 className="font-bold">Recent Orders </h5>{" "}
							<button className="border-2 border-gray-300 rounded-md  px-[1rem]  py-[0.2rem]  ">
								view all
							</button>
						</div>
						<ul className=" w-full  text-[0.9rem]  ">
							<li className="pl-[0.3rem] py-[0.4rem] bg-gray-300 grid grid-cols-2  md:grid-cols-4">
								<p className="hidden  md:flex justify-start items-center  ">
									<RxBox /> ID
								</p>
								<p>product</p>
								<p className="hidden  md:block">Status</p>
								<p>ETA</p>
							</li>

							{recentOrders.map((data) => (
								<li
									key={data.id}
									className=" min-h-[4rem]    place-content-center   text-[0.8rem]  border-b-2  border-b-gray-300  grid  grid-cols-2  md:grid-cols-4">
									<p className="hidden  md:block">{data.id}</p>
									<p className="">
										{data.product}

										<span className="block md:hidden text-gray-500  ">
											{data.id}
										</span>
									</p>
									<p className="hidden  md:block">
										<span
											className={` max-w-fit px-[0.1rem]  rounded-md  block  ${
												data.status === "confirmed"
													? "bg-green-300  text-green-700"
													: data.status === "pending"
													? "bg-yellow-300 text-yellow-700"
													: "text-blue-500"
											}`}>
											{data.status === "confirmed" ? (
												<IoCheckmarkCircle className="inline-block" />
											) : data.status === "pending" ? (
												<MdOutlinePending className="inline-block" />
											) : (
												<LuShip className="inline-block" />
											)}{" "}
											{data.status}
										</span>

										{data.status}
									</p>
									<p>
										{data.eta}

										<span
											className={` max-w-fit px-[0.2rem] md:hidden rounded-md  block  ${
												data.status === "confirmed"
													? "bg-green-300  text-green-700"
													: data.status === "pending"
													? "bg-yellow-300 text-yellow-700"
													: "text-blue-500"
											}`}>
											{data.status === "confirmed" ? (
												<IoCheckmarkCircle className="inline-block" />
											) : data.status === "pending" ? (
												<MdOutlinePending className="inline-block" />
											) : (
												<LuShip className="inline-block" />
											)}{" "}
											{data.status}
										</span>
									</p>
									
								</li>
							))}
						</ul>
					</div>
					recent transactions
					<div className="w-full p-[0.5rem] min-h-full  border-2  border-gray-300   rounded-md">
						<div className="flex  justify-start items-center gap-[3rem]  my-[0.5rem]">
							<h5 className="font-bold">Recent Transactions </h5>{" "}
							<button className="border-2 border-gray-300 rounded-md  px-[0.5rem]  py-[0.2rem]  ">
								view all
							</button>
						</div>
						<ul className=" w-full  text-[0.9rem]  ">
							<li className="pl-[0.3rem] py-[0.4rem] bg-gray-300 grid grid-cols-2  md:grid-cols-4">
								<p className="hidden  md:flex justify-start items-center  ">
									<RxBox /> ID
								</p>
								<p>Date</p>
								<p>Amount</p>
								<p className="hidden  md:block">Status</p>
							</li>

							{recentTransactions.map((data) => (
								<li
									key={data.id}
									className=" min-h-[4rem]    place-content-center   text-[0.8rem]  border-b-2  border-b-gray-300  grid  grid-cols-2  md:grid-cols-4">
									<p className="hidden  md:block">{data.id}</p>
									<p className="">
										{data.date}

										<span className="block md:hidden text-gray-500  ">
											{data.id}
										</span>
									</p>
									<p className="hidden  md:block">
										<span
											className={` max-w-fit px-[0.2rem]  rounded-md  block  ${
												data.status === "completed"
													? "bg-green-300  text-green-700"
													: "bg-yellow-300 text-yellow-700"
											}`}>
										
											{data.status}
										</span>

							
									</p>
									<p>
										{data.amount}

										<span
											className={` max-w-fit px-[0.2rem] md:hidden rounded-md  block  ${
												data.status === "completed"
													? "bg-green-300  text-green-700"
													: "bg-yellow-300 text-yellow-700"
											}`}>
									
											{data.status}
										</span>
									</p>
								
								</li>
							))}
						</ul>
					</div>
				</div>
				billing history
				<div className="w-full p-[0.5rem] min-h-full  border-2  border-gray-300   rounded-md">
					<div className="flex  justify-start items-center gap-[3rem]  my-[0.5rem]">
						<h5 className="font-bold">Billing History </h5>{" "}
						<button className="border-2 border-gray-300 rounded-md  px-[0.5rem]  py-[0.2rem]  ">
							view all
						</button>
					</div>
					<ul className=" w-full  text-[0.9rem]  ">
						

						{billingHistory.map((data) => (
							<li
								key={data.id}
								className=" min-h-[6rem]    place-content-center   text-[0.8rem]  border-b-2  border-b-gray-300  gap-[1.5rem]  grid  grid-cols-2  ">
								<p className="">
									{data.title}-{data.date}
									<span className="block  text-gray-500   bg-green-100  px-[0.5rem] max-w-fit rounded-md ">
										<GoDotFill className="  inline-block text-green-500" />
										{data.status}
									</span>
								</p>
								<p className="hidden  md:block">
									<span
										className={` max-w-fit px-[0.2rem]  rounded-md  block  `}>
									
										{data.amount}
									</span>

								</p>
								<p className="md:hidden">{data.amount}</p>
							
							</li>
						))}
					</ul>
				</div>
			</section> */}
		</section>
	);

	return content;
}
